const SettingTypes = {
  GET_SETTING_MAIL_VARIABLE_REQUEST: 'GET_SETTING_MAIL_VARIABLE_REQUEST',
  GET_SETTING_MAIL_VARIABLE_SUCCESS: 'GET_SETTING_MAIL_VARIABLE_SUCCESS',
  GET_SETTING_MAIL_VARIABLE_ERROR: 'GET_SETTING_MAIL_VARIABLE_ERROR',

  GET_PAYMENT_PAYPAL_REQUEST: 'GET_PAYMENT_PAYPAL_REQUEST',
  GET_PAYMENT_PAYPAL_SUCCESS: 'GET_PAYMENT_PAYPAL_SUCCESS',
  GET_PAYMENT_PAYPAL_ERROR: 'GET_PAYMENT_PAYPAL_ERROR',

  UPDATE_PAYMENT_PAYPAL_REQUEST: 'UPDATE_PAYMENT_PAYPAL_REQUEST',
  UPDATE_PAYMENT_PAYPAL_SUCCESS: 'UPDATE_PAYMENT_PAYPAL_SUCCESS',
  UPDATE_PAYMENT_PAYPAL_ERROR: 'UPDATE_PAYMENT_PAYPAL_ERROR',

  GET_PAYMENT_STRIPE_REQUEST: 'GET_PAYMENT_STRIPE_REQUEST',
  GET_PAYMENT_STRIPE_SUCCESS: 'GET_PAYMENT_STRIPE_SUCCESS',
  GET_PAYMENT_STRIPE_ERROR: 'GET_PAYMENT_STRIPE_ERROR',

  UPDATE_PAYMENT_STRIPE_REQUEST: 'UPDATE_PAYMENT_STRIPE_REQUEST',
  UPDATE_PAYMENT_STRIPE_SUCCESS: 'UPDATE_PAYMENT_STRIPE_SUCCESS',
  UPDATE_PAYMENT_STRIPE_ERROR: 'UPDATE_PAYMENT_STRIPE_ERROR',

  GET_PAYMENT_AUTHORIZENET_REQUEST: 'GET_PAYMENT_AUTHORIZENET_REQUEST',
  GET_PAYMENT_AUTHORIZENET_SUCCESS: 'GET_PAYMENT_AUTHORIZENET_SUCCESS',
  GET_PAYMENT_AUTHORIZENET_ERROR: 'GET_PAYMENT_AUTHORIZENET_ERROR',

  UPDATE_PAYMENT_AUTHORIZENET_REQUEST: 'UPDATE_PAYMENT_AUTHORIZENET_REQUEST',
  UPDATE_PAYMENT_AUTHORIZENET_SUCCESS: 'UPDATE_PAYMENT_AUTHORIZENET_SUCCESS',
  UPDATE_PAYMENT_AUTHORIZENET_ERROR: 'UPDATE_PAYMENT_AUTHORIZENET_ERROR',

  GET_GENERAL_SETTINGS_REQUEST: 'GET_GENERAL_SETTINGS_REQUEST',
  GET_GENERAL_SETTINGS_SUCCESS: 'GET_GENERAL_SETTINGS_SUCCESS',
  GET_GENERAL_SETTINGS_ERROR: 'GET_GENERAL_SETTINGS_ERROR',

  UPDATE_GENERAL_SETTINGS_REQUEST: 'UPDATE_GENERAL_SETTINGS_REQUEST',
  UPDATE_GENERAL_SETTINGS_SUCCESS: 'UPDATE_GENERAL_SETTINGS_SUCCESS',
  UPDATE_GENERAL_SETTINGS_ERROR: 'UPDATE_GENERAL_SETTINGS_ERROR',

  GET_USER_PROFILE_REQUEST: 'GET_USER_PROFILE_REQUEST',
  GET_USER_PROFILE_SUCCESS: 'GET_USER_PROFILE_SUCCESS',
  GET_USER_PROFILE_ERROR: 'GET_USER_PROFILE_ERROR',

  UPDATE_USER_PROFILE_REQUEST: 'UPDATE_USER_PROFILE_REQUEST',
  UPDATE_USER_PROFILE_SUCCESS: 'UPDATE_USER_PROFILE_SUCCESS',
  UPDATE_USER_PROFILE_ERROR: 'UPDATE_USER_PROFILE_ERROR',

  GET_VERIFY_MAIL_REQUEST: 'GET_VERIFY_MAIL_REQUEST',
  GET_VERIFY_MAIL_SUCCESS: 'GET_VERIFY_MAIL_SUCCESS',
  GET_VERIFY_MAIL_ERROR: 'GET_VERIFY_MAIL_ERROR',

  UPDATE_CHANGE_PASSWORD_REQUEST: 'UPDATE_CHANGE_PASSWORD_REQUEST',
  UPDATE_CHANGE_PASSWORD_SUCCESS: 'UPDATE_CHANGE_PASSWORD_SUCCESS',
  UPDATE_CHANGE_PASSWORD_ERROR: 'UPDATE_CHANGE_PASSWORD_ERROR',

  GET_BANK_LIST_REQUEST: 'GET_BANK_LIST_REQUEST',
  GET_BANK_LIST_SUCCESS: 'GET_BANK_LIST_SUCCESS',
  GET_BANK_LIST_ERROR: 'GET_BANK_LIST_ERROR',

  ADD_BANK_REQUEST: 'ADD_BANK_REQUEST',
  ADD_BANK_SUCCESS: 'ADD_BANK_SUCCESS',
  ADD_BANK_ERROR: 'ADD_BANK_ERROR',

  GET_BANK_ITEM_REQUEST: 'GET_BANK_ITEM_REQUEST',
  GET_BANK_ITEM_SUCCESS: 'GET_BANK_ITEM_SUCCESS',
  GET_BANK_ITEM_ERROR: 'GET_BANK_ITEM_ERROR',

  UPDATE_BANK_REQUEST: 'UPDATE_BANK_REQUEST',
  UPDATE_BANK_SUCCESS: 'UPDATE_BANK_SUCCESS',
  UPDATE_BANK_ERROR: 'UPDATE_BANK_ERROR',

  DELETE_BANK_REQUEST: 'DELETE_BANK_REQUEST',
  DELETE_BANK_SUCCESS: 'DELETE_BANK_SUCCESS',
  DELETE_BANK_ERROR: 'DELETE_BANK_ERROR',

  UPDATE_BANK_QUERY_PARAMS: 'UPDATE_BANK_QUERY_PARAMS',

  GET_OFFICE_LIST_REQUEST: 'GET_OFFICE_LIST_REQUEST',
  GET_OFFICE_LIST_SUCCESS: 'GET_OFFICE_LIST_SUCCESS',
  GET_OFFICE_LIST_ERROR: 'GET_OFFICE_LIST_ERROR',

  ADD_OFFICE_REQUEST: 'ADD_OFFICE_REQUEST',
  ADD_OFFICE_SUCCESS: 'ADD_OFFICE_SUCCESS',
  ADD_OFFICE_ERROR: 'ADD_OFFICE_ERROR',

  GET_OFFICE_ITEM_REQUEST: 'GET_OFFICE_ITEM_REQUEST',
  GET_OFFICE_ITEM_SUCCESS: 'GET_OFFICE_ITEM_SUCCESS',
  GET_OFFICE_ITEM_ERROR: 'GET_OFFICE_ITEM_ERROR',

  UPDATE_OFFICE_REQUEST: 'UPDATE_OFFICE_REQUEST',
  UPDATE_OFFICE_SUCCESS: 'UPDATE_OFFICE_SUCCESS',
  UPDATE_OFFICE_ERROR: 'UPDATE_OFFICE_ERROR',

  DELETE_OFFICE_REQUEST: 'DELETE_OFFICE_REQUEST',
  DELETE_OFFICE_SUCCESS: 'DELETE_OFFICE_SUCCESS',
  DELETE_OFFICE_ERROR: 'DELETE_OFFICE_ERROR',

  UPDATE_OFFICE_QUERY_PARAMS: 'UPDATE_OFFICE_QUERY_PARAMS',

  GET_SIGNATURE_LIST_REQUEST: 'GET_SIGNATURE_LIST_REQUEST',
  GET_SIGNATURE_LIST_SUCCESS: 'GET_SIGNATURE_LIST_SUCCESS',
  GET_SIGNATURE_LIST_ERROR: 'GET_SIGNATURE_LIST_ERROR',

  ADD_SIGNATURE_REQUEST: 'ADD_SIGNATURE_REQUEST',
  ADD_SIGNATURE_SUCCESS: 'ADD_SIGNATURE_SUCCESS',
  ADD_SIGNATURE_ERROR: 'ADD_SIGNATURE_ERROR',

  GET_SIGNATURE_ITEM_REQUEST: 'GET_SIGNATURE_ITEM_REQUEST',
  GET_SIGNATURE_ITEM_SUCCESS: 'GET_SIGNATURE_ITEM_SUCCESS',
  GET_SIGNATURE_ITEM_ERROR: 'GET_SIGNATURE_ITEM_ERROR',

  UPDATE_SIGNATURE_REQUEST: 'UPDATE_SIGNATURE_REQUEST',
  UPDATE_SIGNATURE_SUCCESS: 'UPDATE_SIGNATURE_SUCCESS',
  UPDATE_SIGNATURE_ERROR: 'UPDATE_SIGNATURE_ERROR',

  DELETE_SIGNATURE_REQUEST: 'DELETE_SIGNATURE_REQUEST',
  DELETE_SIGNATURE_SUCCESS: 'DELETE_SIGNATURE_SUCCESS',
  DELETE_SIGNATURE_ERROR: 'DELETE_SIGNATURE_ERROR',

  UPDATE_SIGNATURE_QUERY_PARAMS: 'UPDATE_SIGNATURE_QUERY_PARAMS',

  GET_PAYMENT_VEEM_REQUEST: 'GET_PAYMENT_VEEM_REQUEST',
  GET_PAYMENT_VEEM_SUCCESS: 'GET_PAYMENT_VEEM_SUCCESS',
  GET_PAYMENT_VEEM_ERROR: 'GET_PAYMENT_VEEM_ERROR',

  UPDATE_PAYMENT_VEEM_REQUEST: 'UPDATE_PAYMENT_VEEM_REQUEST',
  UPDATE_PAYMENT_VEEM_SUCCESS: 'UPDATE_PAYMENT_VEEM_SUCCESS',
  UPDATE_PAYMENT_VEEM_ERROR: 'UPDATE_PAYMENT_VEEM_ERROR',

  GET_PAYMENT_BANKOFAMERICA_REQUEST: 'GET_PAYMENT_BANKOFAMERICA_REQUEST',
  GET_PAYMENT_BANKOFAMERICA_SUCCESS: 'GET_PAYMENT_BANKOFAMERICA_SUCCESS',
  GET_PAYMENT_BANKOFAMERICA_ERROR: 'GET_PAYMENT_BANKOFAMERICA_ERROR',

  UPDATE_PAYMENT_BANKOFAMERICA_REQUEST: 'UPDATE_PAYMENT_BANKOFAMERICA_REQUEST',
  UPDATE_PAYMENT_BANKOFAMERICA_SUCCESS: 'UPDATE_PAYMENT_BANKOFAMERICA_SUCCESS',
  UPDATE_PAYMENT_BANKOFAMERICA_ERROR: 'UPDATE_PAYMENT_BANKOFAMERICA_ERROR',

  GET_PAYMENT_CLOVER_REQUEST: 'GET_PAYMENT_CLOVER_REQUEST',
  GET_PAYMENT_CLOVER_SUCCESS: 'GET_PAYMENT_CLOVER_SUCCESS',
  GET_PAYMENT_CLOVER_ERROR: 'GET_PAYMENT_CLOVER_ERROR',

  UPDATE_PAYMENT_CLOVER_REQUEST: 'UPDATE_PAYMENT_CLOVER_REQUEST',
  UPDATE_PAYMENT_CLOVER_SUCCESS: 'UPDATE_PAYMENT_CLOVER_SUCCESS',
  UPDATE_PAYMENT_CLOVER_ERROR: 'UPDATE_PAYMENT_CLOVER_ERROR'
};

export default SettingTypes;
